<template>
  <div class="solution-container">
    <div
        class="solution-card"
        v-for="(item, index) in solutionList"
        :key="index"
        :style="{ backgroundImage: `url(${item.bgImage})` }"
        @click="handleDetail(item)"
    >
      <div class="card-content">
        <h3 class="card-title">{{ $t(item.titleKey) }}</h3>
        <p class="card-desc">{{ $t(item.descKey) }}</p>
        <div class="card-link">
          <span @click="$router.push(item.path)">{{ $t('common.viewDetails') }}</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M8.59 16.59L10 18L16 12L10 6L8.59 7.41L13.17 12L8.59 16.59Z" fill="white"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SolutionCard',
  data() {
    return {
      // 解决方案数据（完全匹配截图，可自行修改）
      solutionList: [
        {
          titleKey: 'home.solutions.antiViolation.title',
          descKey: 'home.solutions.antiViolation.desc',
          bgImage: require('@/assets/solution/solution03.webp'),
          path:'/Algorithm/index?id=fa001'
        },
        {
          titleKey: 'home.solutions.mineMonitor.title',
          descKey: 'home.solutions.mineMonitor.desc',
          bgImage: require('@/assets/solution/solution02.webp'),
          path:'/Algorithm/index?id=fa002'
        },
        {
          titleKey: 'home.solutions.chemicalMonitor.title',
          descKey: 'home.solutions.chemicalMonitor.desc',
          bgImage: require('@/assets/solution/solution01.webp'),
          path:'/Algorithm/index?id=fa003'
        }
      ]
    }
  },
  methods: {
    handleDetail(item) {
      console.log('跳转到解决方案详情：', item.link)
      // 可添加路由跳转逻辑
      // this.$router.push(item.link)
    }
  }
}
</script>

<style scoped>
/* 容器：3列等宽网格 */
.solution-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  padding: 4vh 16vh; /* 整体内边距，可根据页面调整 */
  background: #fff;
}

/* 单个卡片：背景图+文字层 */
.solution-card {
  position: relative;
  height: 68vh;
  //border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;

  /* 背景图铺满不变形 */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* 卡片hover效果：轻微上浮+阴影 */
.solution-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0,0,0,0.15);
}

/* 文字内容层：绝对定位在卡片内 */
.card-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 40px 30px;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
  //justify-content: center;
  align-items: center;
  text-align: center;
  /* 半透明遮罩，提升文字可读性 */
  //background: linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.2) 100%);
}

/* 标题样式 */
.card-title {
  font-size: 32px;
  font-weight: bold;
  margin: 100px 0 20px 0;
  line-height: 1.3;
  text-shadow: 0 2px 8px rgba(0,0,0,0.5);
}

/* 描述样式 */
.card-desc {
  font-size: 18px;
  line-height: 1.7;
  margin: 0 0 30px 0;
  max-width: 90%;
  text-shadow: 0 2px 6px rgba(0,0,0,0.4);
}

/* 查看详情链接 */
.card-link {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.solution-card:hover .card-link {
  gap: 10px;
}

/* 响应式适配：平板端2列 */
@media (max-width: 1024px) {
  .solution-container {
    grid-template-columns: repeat(2, 1fr);
    padding: 30px 40px;
  }
  .card-title {
    font-size: 28px;
  }
  .card-desc {
    font-size: 16px;
  }
}

/* 响应式适配：移动端1列 */
@media (max-width: 768px) {
  .solution-container {
    grid-template-columns: 1fr;
    padding: 20px;
  }
  .solution-card {
    height: 360px;
  }
  .card-title {
    font-size: 24px;
  }
  .card-desc {
    font-size: 14px;
  }
}
</style>